/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedResponse } from '../../models/paginated-response';

export interface PosOrdersControllerGetBySession$Params {

/**
 * Session ID to filter orders by
 */
  sessionId: string;

/**
 * Page number (default: 1)
 */
  page?: number;

/**
 * Maximum number of orders to return (default: 20, max: 100)
 */
  limit?: number;
}

export function posOrdersControllerGetBySession(http: HttpClient, rootUrl: string, params: PosOrdersControllerGetBySession$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedResponse>> {
  const rb = new RequestBuilder(rootUrl, posOrdersControllerGetBySession.PATH, 'get');
  if (params) {
    rb.query('sessionId', params.sessionId, {});
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedResponse>;
    })
  );
}

posOrdersControllerGetBySession.PATH = '/pos/orders';
